'use client';
import React from 'react';
import { Box, Card, CardContent, CardMedia } from '@mui/material';
import { ImageCard as ImageCardType } from '@peerless/data-access/strapi';
import { formatMediaUrl } from '../utils';

export const ImageCard: React.FC<ImageCardType> = ({ image, htmlText, linkUrl }) => {
  const formattedImage = image.data?.attributes ? formatMediaUrl(image.data.attributes) : undefined;
  return (
    <Card>
      <CardContent sx={{ padding: '0 !important' }}>
        {image && <CardMedia component={'img'} alt={'test'} image={formattedImage} />}
        {htmlText && (
          <Box sx={{ p: 2 }}>
            <div dangerouslySetInnerHTML={{ __html: htmlText }} />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
